/*
 *  I06SEPHYDCalcul.js
 *
 *  Created by Sébastien Hecart on 2017-12-31 10:46:15 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { tubeAcierWithDiametre } from '@batical/data/src'
import { I06SEPHYD_State } from '@batical/types/src'
//TODO IF REQUIREDimport {} from '@batical/types/src';
function I06SEPHYD_docalcul(state: I06SEPHYD_State) {
  let result: number = 0.0
  let result3: number = 0.0
  let qChecking: number = 0.0
  if (state.in_index_puissanceOrQ === 0 && state.in_puissQ > 0 && state.in_deltaT > 0) {
    qChecking = (353.68 * state.in_puissQ) / (1.16 * state.in_deltaT)
    state.in_debit = Math.round((state.in_puissQ / (1.16 * state.in_deltaT)) * 1000) / 1000
    state = checkVMaxWithQ(qChecking, state)
    result = Math.sqrt(((state.in_puissQ / (1.16 * state.in_deltaT)) * 353.68) / state.in_velocite)
    result3 = result * 3
  } else if (state.in_index_puissanceOrQ === 1 && state.in_debit > 0) {
    state.in_puissQ = Math.round(state.in_debit * 1.16 * state.in_deltaT * 1000) / 1000
    qChecking = 353.68 * state.in_debit
    state = checkVMaxWithQ(qChecking, state)
    result = Math.sqrt((state.in_debit * 353.68) / state.in_velocite)
    result3 = result * 3
  } else {
    state.res_DN1 = ''
    state.res_DN3 = ''
    state.res_distanceGrande = 0.0
    state.res_distancePetite = 0
    state.res_vitesseBouteille = 0
    return state
  }

  const tube = tubeAcierWithDiametre(result)

  if (tube != null) {
    state.res_DN1 = tube.name
    const tube3 = tubeAcierWithDiametre(result3)
    if (tube3 != null) {
      state.res_DN3 = tube3.name
      state.res_distancePetite = tube3.diamInt
      state.res_distanceGrande = tube3.diamInt * 2
      state.res_vitesseBouteille = qChecking / Math.pow(state.res_distancePetite, 2)
    }
  } else {
    state.res_DN1 = ''
    state.res_DN3 = ''
    state.res_distanceGrande = 0
    state.res_distancePetite = 0
    state.res_vitesseBouteille = 0
    return state
  }

  return state
}

function checkVMaxWithQ(qCheck: number, state: I06SEPHYD_State): I06SEPHYD_State {
  state.res_maxVCalcule = Math.pow(qCheck, 0.2) / Math.pow(50, 0.4)
  //truncate a 2 decimal
  state.res_maxVCalcule = Math.trunc(state.res_maxVCalcule * 100) / 100
  if (state.res_maxV !== state.res_maxVCalcule) {
    //switch maxV only if not debug
    state.res_maxV = state.res_maxVCalcule
    if (state.res_maxV > 1.5) {
      state.res_maxV = 1.5 // hardcoded max value
    }
    if (state.in_velocite > state.res_maxV) {
      state.in_velocite = state.res_maxV
    }
  }
  state.invalidated = false
  return state
}

export default I06SEPHYD_docalcul
